import { render, staticRenderFns } from "./AddHouse.vue?vue&type=template&id=500048ba&scoped=true"
import script from "./AddHouse.vue?vue&type=script&lang=js"
export * from "./AddHouse.vue?vue&type=script&lang=js"
import style0 from "./AddHouse.vue?vue&type=style&index=0&id=500048ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "500048ba",
  null
  
)

export default component.exports